import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import useInvoke from "../../Tools/Invoker";
import DynamicGrid from "../../Tools/DynamicGrid";
import CheckToken from "../../_Login/CheckToken";

const Oils = () => {

    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();

    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    let response95 = useInvoke("WebApps", "95", {});

    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);

    useEffect(() => {

        if (response95.data.payload != undefined) {

            let myData = JSON.parse(response95.data.payload).data;
            let rowsList = [];

            myData.forEach((entry, index) => {

                let row = [
                    { type: "text", content: { text: `${entry[0]}` } },
                    { type: "link", content: { text: `${entry[1]}`, link: `/Oils/Details/${entry[0]}` } },
                    { type: "text", content: { text: `${entry[2]}` } },
                    { type: "text", content: { text: `${entry[3]}` } }
                ];

                rowsList.push(row);
            });

            setColumns(["Oil ID", "Oiler Name", "Viscosity (cSt)", "Description"]);
            setRows(rowsList);
        }

    }, [response95.data.payload]);

    document.title = "Electrostatic Oilers";
    return (

        <>
            <div className="oilers">
                {user["email"] != undefined &&
                    <>
                        <div className="container" style={{ margin: "auto" }}>

                            {/* <div style={{ display: "flex", flexDirection: "row", margin: "0px", justifyContent: "space-between" }}>
                                <Link to="/Oilers" className="btn btn-default" style={{ width: "auto" }}>Back</Link>
                            </div> */}

                            <h2>Oils</h2>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>
                                    <p><Link className="btn btn-primary" to="/Oils/New">New Oil</Link></p>
                                </div>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>

                                </div>
                            </div>

                            {columns && rows && <DynamicGrid columnNames={columns} tableData={rows} sortable={true} defaultsortindex={1} descending={true} />}

                        </div>

                    </>
                }

            </div>

        </>
    );
}

export default Oils;